<div class="modal" id="billing" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
  <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header popup-header">
        <h5 class="modal-title" id="billingTitle" style="line-height: 20px;">
          Account Billing Profile
        </h5>
        <button type="button" id="closeBilling" (click)="cancelClicked()" class="close" data-dismiss="modal"
          aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form #billingForm="ngForm" novalidate (ngSubmit)="saveClicked(billingForm)">
        <div class="modal-body pt-1">

          <div class="row mt-1">
            <div class="col">
              <label><span class="maroon astrisk">&#10033;&nbsp;</span>Billing Cycle</label>
              <div class="row">
                <div class="col">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="monthlyRadio" name="monthly" value="MONTHLY"
                      [(ngModel)]="billingModal.billingCycle" class="custom-control-input" disabled>
                    <label class="custom-control-label" for="monthlyRadio">Monthly</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="quarterlyRadio" name="quarterly" value="QUARTERLY"
                      [(ngModel)]="billingModal.billingCycle" class="custom-control-input" disabled>
                    <label class="custom-control-label" for="quarterlyRadio">Quarterly</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="halfYearlyRadio" name="halfYearly" value="HALF_YEARLY"
                      [(ngModel)]="billingModal.billingCycle" class="custom-control-input" disabled>
                    <label class="custom-control-label" for="halfYearlyRadio">Half-Yearly</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="yearlyRadio" name="yearly" value="YEARLY"
                      [(ngModel)]="billingModal.billingCycle" class="custom-control-input" disabled>
                    <label class="custom-control-label" for="yearlyRadio">Yearly</label>
                  </div>
                </div>
              </div>

              <!--Invoice Creation-->
              <!-- <label><span class="maroon astrisk mt-2">&#10033;&nbsp;</span>Invoice Creation</label>
              <div class="row">
                <div class="col">
                  <div *ngFor="let invoiceCreation of invoiceCreationOptions"
                    class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="{{invoiceCreation}}Radio" name="{{invoiceCreation}}Radio"
                      value="{{invoiceCreation}}" [(ngModel)]="billingModal.invoiceCreation"
                      class="custom-control-input" disabled>
                    <label class="custom-control-label"
                      for="{{invoiceCreation}}Radio">{{invoiceCreation | customText}}</label>
                  </div>
                </div>
              </div> -->

              <div class="form-group mb-1 mt-2">
                <label><span *ngIf="billingModal.invoiceCreation == invoiceCreationOptions[0]"
                    class="maroon astrisk">&#10033;&nbsp;</span>Billing Date</label>
                <input type="number" class="form-control" pattern="\d*" style="width:30%"
                  [(ngModel)]="billingModal.billingDate" [customMin]="1" [customMax]="28" maxlength="2"
                  name="billingDate" #billingDate="ngModel" disabled>
                <small *ngIf="billingDate.errors && billingForm.submitted" class="text-danger text-center">
                  <p class="mb-0" *ngIf="billingDate.errors.required">*Required</p>
                  <p class="mb-0"
                    *ngIf="!billingDate.errors.required || billingDate.errors?.customMin || billingDate.errors?.customMax">
                    Billing Date should be integer and in between 1 & 28.
                  </p>
                </small>
              </div>

              <label class="mt-2"><span class="maroon astrisk">&#10033;&nbsp;</span>Currency</label>
              <div class="row">
                <div class="col">
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="usdRadio" name="usd" [value]="utilService.countryData.currency" [(ngModel)]="billingModal.currency"
                      class="custom-control-input" disabled>
                    <label class="custom-control-label" for="usdRadio">{{utilService.countryData.currency}}</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="cadRadio" name="cad" value="CAD" [(ngModel)]="billingModal.currency"
                      class="custom-control-input" disabled>
                    <label class="custom-control-label" for="cadRadio">CAD</label>
                  </div>
                  <div class="custom-control custom-radio custom-control-inline">
                    <input type="radio" id="pesoRadio" name="peso" value="PESO" [(ngModel)]="billingModal.currency"
                      class="custom-control-input" disabled>
                    <label class="custom-control-label" for="pesoRadio">Peso</label>
                  </div>
                </div>
              </div>
        
              <div class="form-group mb-1 mt-2">
                <label><span class="maroon astrisk">&#10033;&nbsp;</span>Payment Term</label>
                <input type="number" class="form-control" pattern="\d*" style="width:30%"
                  [(ngModel)]="billingModal.paymentTerm" [customMin]="0" [customMax]="90" maxlength="3" name="paymentTerm"
                  #paymentTerm="ngModel" disabled>
                  <small *ngIf="paymentTerm.errors && billingForm.submitted" class="text-danger text-center">
                    <p class="mb-0" *ngIf="paymentTerm.errors.required">*Required</p>
                    <p class="mb-0"
                      *ngIf="!paymentTerm.errors.required || paymentTerm.errors?.customMin || paymentTerm.errors?.customMax">
                      Payment term should be integer and in between 0 & 90.
                    </p>
                  </small>
              </div>
              
              <div class="row mt-2 mb-1">
                <div class="col-9 mt-2">
                  <label class="font14-600">Billing Address</label>
                </div>
                <div class="col-3 mt-2 text-right">
                  <i *ngIf="!editAddress" (click)="onEdit()" class="pointer fas fa-edit cursor-pointer maroon" 
                    data-toggle="tooltip" data-placement="right" title="Update billing address"></i>
                  <i *ngIf="editAddress" (click)="onCancelEdit()" class="pointer fa fa-window-close cursor-pointer maroon"
                    data-toggle="tooltip" data-placement="right" title="Cancel" ></i>
                </div>
                <div class="col-12 mt-2">
                  <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input pointer" id="defaultAddress"
                      [checked]="billingModal.isAccountAddress" (change)="billingModal.isAccountAddress = !billingModal.isAccountAddress" [disabled]="!editAddress">
                    <label class="custom-control-label pointer" for="defaultAddress">Same as account
                      address</label>
                  </div>
                </div>
              </div>

              <div class="mt-1" *ngIf="!billingModal.isAccountAddress">

                <div class="form-group mb-1">
                  <label><span class="maroon astrisk">&#10033;&nbsp;</span>Street
                    Address</label>
                  <input type="text" class="form-control" [(ngModel)]="billingModal.address.street" name="street"
                    #street="ngModel" [disabled]="!editAddress" required>
                  <small class="text-danger text-center" *ngIf="street.errors && billingForm.submitted">
                    <p class="mb-0" *ngIf="street.errors.required">*Required</p>
                  </small>
                </div>
                <div class="row">
                  <div class="col mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>Zip Code</label>
                      <input type="text" class="form-control" [(ngModel)]="billingModal.address.zipCode" name="zip" #zip="ngModel"
                        pattern="[0-9]{5}" (input)="getZipCodeDetails($event.target.value)" maxlength="5" [disabled]="!editAddress"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');" required>
                      <small class="text-danger text-center" *ngIf="zip.errors && billingForm.submitted">
                        <p class="mb-0" *ngIf="zip.errors.required">*Required</p>
                        <p class="mb-0" *ngIf="!zip.errors.required && !invalidZipCode">Invalid Zip Code</p>
                      </small>
                      <small class="text-danger text-center" *ngIf="invalidZipCode">
                        <p class="mb-0">Invalid Zip Code</p>
                      </small>
                    </div>
                  </div>
                  <div class="col pl-0 mt-1">
                    <div class="form-group mb-1">
                      <label>Plus4 Code</label>
                      <input type="text" class="form-control" [(ngModel)]="billingModal.address.plus4Code" name="plus4Code"
                        #plus4Code="ngModel" pattern="[0-9]{4}" maxlength="4" minlength="4"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');">
                      <small class="text-danger text-center" *ngIf="plus4Code.errors && billingForm.submitted">
                        <p class="mb-0" *ngIf="plus4Code.errors?.pattern">Invalid Plus4 Code</p>
                      </small>
                    </div>
                  </div>
                  </div>
                <div class="row">
                  <div class="col mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>City</label>
                      <input type="text" class="form-control" [(ngModel)]="billingModal.address.city" name="city"
                        #city="ngModel" [disabled]="!editAddress" required>
                      <small class="text-danger text-center" *ngIf="city.errors && billingForm.submitted">
                        <p class="mb-0" *ngIf="city.errors.required">*Required</p>
                      </small>
                    </div>
                  </div>
                  <div *ngIf="editAddress" class="col pl-0 mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>State</label>
                      <!-- <input type="text" class="form-control" [(ngModel)]="billingModal.address.state" name="stateInput"
                        [disabled]="true"> -->
                      <select id="model" class="w-100" aria-placeholder="Select State"
                        [(ngModel)]="billingModal.address.state" name="state" #state="ngModel" required>
                        <option [ngValue]="null">Select State</option>
                        <option *ngFor="let state of stateList" value={{state}}>{{state}}</option>
                      </select>
                      <small class="text-danger text-center" *ngIf="state.errors && billingForm.submitted">
                        <p class="mb-0" *ngIf="state.errors.required">*Required</p>
                      </small>
                    </div>
                  </div>
                  <div *ngIf="!editAddress" class="col pl-0 mt-1">
                    <div class="form-group mb-1">
                      <label><span class="maroon astrisk">&#10033;&nbsp;</span>State</label>
                      <input type="text" class="form-control" [(ngModel)]="billingModal.address.state" name="stateInput"
                        [disabled]="true">
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="editAddress" class="row mt-3">
                <div class="col-12 text-right">
                  <button type="submit" class="btn btn-primary border btn-80">Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>